import React, { useState, useEffect } from "react";
// Components
import ProjectBox from "./ProjectBox";
import TypeBubble from "../Components/TypeBubble";

// Variables
import { ProjectTypes } from "../../variables";

const Projects = ({
  projects,
  activeProject,
  setActiveProject,
  showProjectForm,
  setShowProjectForm,
  onAddProject,
  onUpdateProjects,
  isLoading,
}) => {
  const [projectName, setProjectName] = useState("");
  const [selectedProjectType, setSelectedProjectType] = useState();
  const [contextMenuData, setContextMenuData] = useState(false);

  useEffect(() => {
    // Reset form
    setSelectedProjectType();
    setProjectName("");
  }, [showProjectForm]);

  // Add Project Form Classes
  let popupClasses = `absolute  ${
    showProjectForm ? "block" : "hidden"
  } top-[60px] right-0 w-4/4  bg-white dark:bg-primary-dark border-2 border-slate-200 dark:border-indigo-500 text-center rounded-xl shadow-xl dark:shadow-lg dark:shadow-indigo-800 py-3 px-5 z-10`;

  const projectTypesList = [
    ProjectTypes.WORK,
    ProjectTypes.SCHOOL,
    ProjectTypes.PERSONAL,
  ];

  const onChangeStarred = (value, project) => {
    // Get projects with updated project starred value
    let updatedProjects = [
      ...projects.map((p) => {
        if (p._ID === project._ID) return { ...p, _Starred: value };
        else return p;
      }),
    ];

    onUpdateProjects(updatedProjects);
  };

  const onChangeContextMenu = (e) => {
    console.log("e.target", e.target);
  };

  // Sorting
  let sortedProjects = projects ? [...projects] : [];

  // Put starred projects on top
  sortedProjects.sort((a, b) => b._Starred - a._Starred);

  return (
    <div className="flex flex-col h-full ">
      {/* Label + Add button */}
      <div className="relative flex justify-between align-center my-4 px-1.5">
        <h1 className="text-4xl">Projects</h1>
        <button
          onClick={(e) => {
            setShowProjectForm(!showProjectForm);
            e.stopPropagation();
          }}
          className="w-12 h-12 my-auto rounded-full bg-indigo-500 hover:bg-indigo-600"
        >
          {/* Plus icon */}
          <i className="text-white fas fa-plus text-xl"></i>
        </button>
        {/* Add project form pop up */}
        <div onClick={(e) => e.stopPropagation()} className={popupClasses}>
          <h2 className="text-2xl mb-5 mt-1">Add project</h2>
          <input
            type="text"
            placeholder="Name"
            value={projectName}
            onChange={(e) => setProjectName(e.target.value)}
            className={`w-full border-2 border-indigo-400 bg-slate-50 px-4 mb-4 rounded-full dark:placeholder-slate-300 text-slate-700 dark:text-white dark:bg-indigo-900`}
          />
          <div className="flex flex-wrap justify-center w-full">
            {projectTypesList.map((type, idx) => (
              <div className="mx-1 mb-2">
                <TypeBubble
                  type={type}
                  active={selectedProjectType === type}
                  clickable={true}
                  onClick={() => setSelectedProjectType(type)}
                  key={idx}
                />
              </div>
            ))}
          </div>
          <button
            onClick={
              !isLoading
                ? () => onAddProject(projectName, selectedProjectType)
                : () => {}
            }
            className="bg-indigo-500 hover:bg-indigo-600 py-2 px-6 text-white rounded-full mt-3 mb-2"
          >
            Create
          </button>
        </div>
      </div>
      <div className="h-full overflow-y-auto pr-4 mb-4 pl-1.5 scrollbar-thin scrollbar-thumb-indigo-500 scrollbar-thumb-rounded">
        {/* Project list */}
        {sortedProjects &&
          sortedProjects.map((project, idx) => (
            <ProjectBox
              name={project._Name}
              type={project._Type}
              starred={project._Starred}
              onChangeStarred={(value) => onChangeStarred(value, project)}
              progress={project._Progress}
              active={activeProject && project._ID === activeProject._ID}
              onClick={() => setActiveProject(project)}
              key={idx}
              onChangeContextMenu={(e) =>
                setContextMenuData({
                  achorEl: e.currentTarget,
                  type: "project",
                })
              }
            />
          ))}
        {/* Context menu */}
        {/* {contextMenuData && (
          // Pop up
        )} */}
      </div>
    </div>
  );
};

export default Projects;
